//const API_BASE_URL = "http://localhost:5239/api";
const API_BASE_URL = "https://shaml-api-gzbhc8brfeamc0gr.uaenorth-01.azurewebsites.net/api";
 
export async function getActiveUsers() {
  const res = await fetch(`${API_BASE_URL}/ActiveUsers`);
  if (!res.ok) throw new Error("Failed to fetch groups");
  return res.json();
}
export async function getGroups() {
  const res = await fetch(`${API_BASE_URL}/groups`);
  if (!res.ok) throw new Error("Failed to fetch groups");
  return res.json();
}

export async function addGroup(group) {
  
  const res = await fetch(`${API_BASE_URL}/Groups`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(group),
  });
  if (!res.ok) throw new Error("Failed to add group");
  return res.json();
}

export async function updateGroup(group) {
  const res = await fetch(`${API_BASE_URL}/groups`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(group),
  });
  if (!res.ok) throw new Error("Failed to update group");
  return res.ok;
}

export async function deleteGroup(id) {
  const res = await fetch(`${API_BASE_URL}/groups/${id}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error("Failed to delete group");
  return res.ok;
}

export const getSubGroups = async () => {
  const response = await fetch(`${API_BASE_URL}/SubGroups`);
  if (!response.ok) throw new Error("Failed to fetch subgroups");
  return response.json();
};

export const addSubGroup = async (subGroup) => {
  const response = await fetch(`${API_BASE_URL}/SubGroups`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(subGroup),
  });
  if (!response.ok) throw new Error("Failed to add subgroup");
  return response.json();
};

export const updateSubGroup = async (subGroup) => {
  const response = await fetch(`${API_BASE_URL}/SubGroups`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(subGroup),
  });
  if (!response.ok) throw new Error("Failed to update subgroup");
  return response.ok;
};

export const deleteSubGroup = async (id) => {
  const response = await fetch(`${API_BASE_URL}/SubGroups/${id}`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error("Failed to delete subgroup");
  return response.ok;
};
export const getUserPermissions = async () => {
  const response = await fetch(`${API_BASE_URL}/Permissions`);
  if (!response.ok) throw new Error("Failed to fetch permissions");
  return response.json();
};

export const addUserPermission = async (permission) => {
  const response = await fetch(`${API_BASE_URL}/Permissions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(permission),
  });
  if (!response.ok) throw new Error("Failed to add permission");
  return response.json();
};

export const updateUserPermission = async (permission) => {
  const response = await fetch(`${API_BASE_URL}/Permissions/${permission.permissionID}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(permission),
  });
  if (!response.ok) throw new Error("Failed to update permission");
  return response.ok;
};

export const deleteUserPermission = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Permissions/${id}`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error("Failed to delete permission");
  return response.ok;
};

export const getUsers = async () => {
  const response = await fetch(`${API_BASE_URL}/Users`);
  if (!response.ok) throw new Error('Failed to fetch users');
  return response.json();
};

// Add a new user
export const addUser = async (user) => {
  const response = await fetch(`${API_BASE_URL}/Users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  });
  if (!response.ok) throw new Error('Failed to add user');
  return response.json();
};

// Update an existing user
export const updateUser = async (user) => {
  const response = await fetch(`${`${API_BASE_URL}/Users`}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  });
  if (!response.ok) throw new Error('Failed to update user');
  return response.ok;
};

// Delete a user by ID
export const deleteUser = async (id) => {
  const response = await fetch(`${`${API_BASE_URL}/Users`}/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete user');
  return response.ok;
};

export const getUserRoles = async () => {
  const res = await fetch(`${API_BASE_URL}/UserRoles`);
  if (!res.ok) throw new Error("Failed to fetch user roles");
  return res.json();
};

export const addUserRole = async (userRole) => {
  const res = await fetch(`${API_BASE_URL}/UserRoles`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userRole),
  });
  if (!res.ok) throw new Error("Failed to add user role");
  return res.json();
};

export const updateUserRole = async (userRole) => {
  if (!userRole.userRolesID) throw new Error("userRolesID is required for update");
  const res = await fetch(`${API_BASE_URL}/UserRoles`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userRole),
  });
  if (!res.ok) throw new Error("Failed to update user role");
  return res.ok;
};

export const deleteUserRole = async (id) => {
  const res = await fetch(`${API_BASE_URL}/UserRoles/${id}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error("Failed to delete user role");
  return res.ok;
};

export const getTrainingMaterials = async () => {
  const response = await fetch(`${API_BASE_URL}/TrainingMaterials`);
  if (!response.ok) throw new Error("Failed to fetch training materials");
  return response.json();
};

export const addTrainingMaterial = async (material) => {
  const response = await fetch(`${API_BASE_URL}/TrainingMaterials`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(material),
  });
  if (!response.ok) throw new Error("Failed to add training material");
  return response.json();
};

export const updateTrainingMaterial = async (material) => {
  if (!material.trainingMaterialID)
    throw new Error("trainingMaterialID is required for update");

  const response = await fetch(`${API_BASE_URL}/TrainingMaterials`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(material),
  });
  if (!response.ok) throw new Error("Failed to update training material");
  return response.ok;
};

export const deleteTrainingMaterial = async (id) => {
  const response = await fetch(`${API_BASE_URL}/TrainingMaterials/${id}`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error("Failed to delete training material");
  return response.ok;
};

export const getTrainingMaterialsByEmail = async (Email) => {
  const response = await fetch(`${API_BASE_URL}/TrainingMaterials/accessible/${Email}`);
  if (!response.ok) throw new Error("Failed to fetch training materials");
  return response.json();
};